<template>
  <div class="header">
    <a class="logo" href="/"><img src="/public/lmk_text@2x.png" /></a>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="stylus">
.header
  background-color: #FFFC00;
  height 80px
  overflow hidden
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  a img
    width: 70px;


</style>


// WEBPACK FOOTER //
// Header.vue